import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DirectSubscriptionService } from '../../services/direct-subscription.service';

@Component({
  standalone: false,
  templateUrl: './direct-trial.component.html',
  styleUrls: ['./direct-trial.component.scss'],
})
export class DirectTrialComponent implements OnInit {
  loading = true;

  constructor(
    private directSubscription: DirectSubscriptionService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.directSubscription.subscriptionStatus$.subscribe((res) => {
      if (!res) {
        this.loading = false;
        this.router.navigate(['/direct']);
      } else {
        this.router.navigate(['/demo/direct']);
      }
    });
  }
}
